import { Injectable } from "@angular/core";
import { UserService } from '../../assabil-kernel/services/user-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { BasicItem } from 'src/app/tools/models/dtos/basic-item';



@Injectable({
    providedIn: 'root'
})
export class SecurityService {

    constructor(
        public userService       : UserService,
        protected networkService : LeanNetworkService) {
    }
        

    login(login : string, password : string, roleCode : string): Promise<BasicItem[]> {
        return new Promise((resolve, reject) => {
            let request: BaseRequest = new BaseRequest(this.userService.userInfo);

            request.login           = login;
            request.password        = password;
            request.sessionRoleCode  = roleCode;
            
            this.networkService.post("security/login", request).then((response: any) => {
                if (response.items)    {
                    resolve(response.items);
                    return;
                }
                this.userService.userInfo            = new UserInfo();
                this.userService.userInfo.person     = response.person;
                this.userService.userInfo.token      = response.person.token;
                this.userService.userInfo.login      = response.person.login;
                this.userService.userInfo.services   = response.services;
                this.userService.userInfo.menus      = response.menus;

                resolve(null);
            }, error => {
                reject(error);
            }
            );
        });
    }

               
    passwordChange(login: string, password: string, newPassword: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);

        request.login = login;
        request.password = password;
        request.strArg1 = newPassword;
        
        this.networkService.post("security/passwordChange", request).then((response: any) => {
            resolve(true);
        }, error => {
            reject(error);
        }
        );
    });
    }
    
      
    credentialsSet(perssonCode : string, login : string, password : string) : Promise<boolean>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.code    = perssonCode;
        request.strArg1 = login;
        request.strArg2 = password;

        return new Promise((resolve, reject) => {
            this.networkService.post("security/credentialsSet", request).then((response: any) => {
                resolve(true);   
            }, error => {
                reject(error);
            });
        });
    }

    logout(){
        this.userService.userInfo = null;
    }

    isLogged() : boolean {
        return (this.userService.userInfo != null);
    }
    
}